module.exports = __webpack_public_path__ + "b4c38820b4075b35865fe29cd7ef9f71.jpg";